import languages from "@cospired/i18n-iso-languages";

languages.registerLocale(require("@cospired/i18n-iso-languages/langs/de.json"));
languages.registerLocale(require("@cospired/i18n-iso-languages/langs/en.json"));
